import React from 'react';
import SiteNav from './components/SiteNav';
import './App.css';

const SUPPORT_EMAIL = 'bestaudiobooksforfree@gmail.com';
const SUPPORT_NAME = 'Scott Mansfield';
const SITE_NAME = 'Best Audio Books For Free';

function SupportPage() {
  return (
    <div
      className="App index-page"
      style={{
        backgroundImage: `url('/background/background.png')`,
        backgroundColor: '#f0f0f0'
      }}
    >
      <SiteNav />
      <header className="App-header index-header">
        <div className="index-panel info-panel">
          <h2 className="index-title">Support</h2>
          <p className="index-subtitle">
            Need help with the site or have a question about an audiobook? Reach out using the
            contact details below.
          </p>

          <h2 className="index-title">Mansfieldian App Support</h2>
          <p className="index-subtitle">
            For help with Mansfieldian, our alternative clock and calendar for iPhone and iPad, email <a
                    className="info-mailto"
                    href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(`${SITE_NAME} Support`)}`}
                  >
                    {SUPPORT_EMAIL}
                  </a>. Please include your device model, iOS version, and a description of the problem.
          </p>

          <div className="info-card">
            <h3>Contact Information</h3>
            <dl className="info-details">
              <div className="info-row">
                <dt>Name</dt>
                <dd>{SUPPORT_NAME}</dd>
              </div>
              <div className="info-row">
                <dt>Site</dt>
                <dd>{SITE_NAME}</dd>
              </div>
              <div className="info-row">
                <dt>Email</dt>
                <dd>
                  <a
                    className="info-mailto"
                    href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(`${SITE_NAME} Support`)}`}
                  >
                    {SUPPORT_EMAIL}
                  </a>
                </dd>
              </div>
            </dl>

            <a
              className="info-cta"
              href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(`${SITE_NAME} Support`)}`}
            >
              Email Me
            </a>
          </div>

          <p className="info-note">
            We typically reply as soon as we can. Please include the book title or page you need
            help with so we can assist faster.
          </p>
        </div>
      </header>
    </div>
  );
}

export default SupportPage;
